import React from 'react';
import './ModalMessage.scss';
import clsx from 'clsx';

export const ModalMessage = ({ type = 'success', message, onClose }) => {
	return (
		<div className='modal-backdrop'>
			<div className='modal-box'>
				<div className='modal-header'>
					<h5 className={clsx('modal-title', type)}>
						{type === 'success' ? 'Éxito' : 'Error'}
					</h5>
				</div>
				<div className='modal-body'>
					<p style={{ whiteSpace: 'pre-line' }}>{message}</p>
				</div>
				<div className='modal-footer'>
					<button
						className={clsx('btn', 'btn-close', type)}
						onClick={onClose}
					>
						Cerrar
					</button>
				</div>
			</div>
		</div>
	);
};
